<script>
import CoreComponent from '../../../../../../../dow-platform/ui.frontend/src/dow-platform/components/core/CoreComponent.vue'

export default {
    extends: CoreComponent,

    mounted() {
        if (!this.cmpEl) return
    }
}
</script>

<style lang="scss">
    @import './flex-grid.scss';
</style>